(function () {
  const initAboutRecommendationSliders = (root = document) => {
    if (typeof Swiper === 'undefined') return;

    root.querySelectorAll('.about__recommendations-slider').forEach((slider) => {
      if (slider.swiper) return;

      new Swiper(slider, {
        slidesPerView: 2.1,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        watchOverflow: false,
        freeMode: {
          enabled: true,
          sticky: false
        },
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true
        },
        scrollbar: {
          el: slider.querySelector('.swiper-scrollbar'),
          draggable: true
        },
        breakpoints: {
          576: {
            slidesPerView: 2.25
          },
          990: {
            slidesPerView: 2.5,
            spaceBetween: 10
          }
        }
      });
    });
  };

  const refreshAboutRecommendationSliders = (container) => {
    if (!container) return;

    container.querySelectorAll('.about__recommendations-slider').forEach((slider) => {
      if (slider.swiper) {
        slider.swiper.update();
        slider.swiper.scrollbar?.updateSize();
      }
    });
  };

  const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
      const description = $(this).siblings(".about__accordion-description").eq($(this).index())[0];

			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300, function () {
              initAboutRecommendationSliders(description);
              refreshAboutRecommendationSliders(description);
            });
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    if (!imagesWrapper) return;
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
    initAboutRecommendationSliders(document);
    refreshAboutRecommendationSliders(document);
  });

  initProductAccordion();
  initZoomImage();
  initAboutRecommendationSliders(document);
  refreshAboutRecommendationSliders(document);
})();
